module.exports = __webpack_public_path__ + "img/sand-rock-big-10.3a74d893.png";